(function () {
  const root = document.querySelector('[data-pd-review]');
  if (!root) return;

  const designsWrap = root.querySelector('[data-pd-review-designs]');
  const builderUrl =
    (document.querySelector('#shopify-section-' + root.closest('[id^="shopify-section-"]')?.id)?.dataset?.builderUrl) ||
    null;

  // Helper: escape HTML
  const esc = (s) =>
    String(s ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

const PART_ORDER = [
  'BODICE',
  'SLEEVES',
  'SILHOUETTE',
  'SKIRT',
  'BACKLINE',
  'CLOSURE',
  'TRAIN',
  'BACK',
  'MAGIC',
  'PRODUCTION',
  'FIT',
];

const PART_LABELS = {
  'BUILDER-BODICES': 'Bodice',
  'BODICES': 'Bodice',

  'BUILDER-SLEEVES': 'Sleeves',
  'SLEEVES': 'Sleeves',

  'BUILDER-SILHOUETTE': 'Silhouette',
  'SILHOUETTE': 'Silhouette',

  'BUILDER-SKIRTS': 'Skirt',
  'SKIRTS': 'Skirt',
  'SKIRT': 'Skirt',

  'BUILDER-BACKS': 'Back',
  'BACKS': 'Back',
  'BACK': 'Back',

  'BACKLINE': 'Backline',
  'CLOSURE': 'Closure',
  'TRAIN': 'Train',

  'BUILDER-MAGIC': 'Magic',
  'MAGIC': 'Magic',

  'PRODUCTION': 'Timeline',
  'FIT': 'Fit Path'
};

function normalizePartKey(s) {
  return String(s || '')
    .trim()
    .toUpperCase()
    .replace(/^BUILDER-/, '')      // BUILDER-BODICES -> BODICES
    .replace(/S$/, '');            // BODICES -> BODICE, SKIRTS -> SKIRT (rough but works)
}

function getDisplayRow(item) {
  const partProp = getProp(item, 'Paper Dolls Part') || '';
  const selProp  = getProp(item, 'Selection') || '';

  const productName = (item && (item.product_title || item.title)) ? (item.product_title || item.title) : '';
  const productClean = String(productName || '').trim();

  // If Selection is in the format "Label: Value", prefer that.
  const m = String(selProp).match(/^([^:]+)\s*:\s*(.+)$/);
  if (m) {
    const left = m[1].trim();   // e.g. "Bodice" OR "Backline"
    const rightRaw = m[2].trim();

    // Keep BACKS slots clean (you said these look good already)
    const isBackSlot = /^(backline|closure|train)$/i.test(left);

    // For EVERYTHING else, force the parent product name into the display
    // so it reads: "February — Natural Waist, Ivory"
    const right = (!isBackSlot && productClean)
      ? (rightRaw.toLowerCase().includes(productClean.toLowerCase())
          ? rightRaw
          : `${productClean} — ${rightRaw}`)
      : rightRaw;

   const leftUp = String(left || '').trim().toUpperCase();      // "BUILDER-BODICES"
const leftMapped = PART_LABELS[leftUp] || left;              // "Bodice"

return {
  partText: leftMapped,
  partKey: normalizePartKey(leftUp),
  selText: right
};

  }

  // Fallback if Selection wasn't formatted:
  const mapped = PART_LABELS[String(partProp).toUpperCase()] || partProp || 'Part';

  // Always include product name in fallback too
  const fallbackSel =
    [productClean, item.variant_title].filter(Boolean).join(' — ') ||
    selProp ||
    'Selection';

  return {
    partText: mapped,
    partKey: normalizePartKey(mapped || partProp),
    selText: fallbackSel
  };
}



  function getProp(item, key) {
    return item && item.properties ? item.properties[key] : undefined;
  }

  function getDesignId(item) {
    return getProp(item, 'Design ID') || getProp(item, 'Design') || null;
  }
  function getDesignSessionId() {
  try {
    return window.sessionStorage.getItem('pd_design_session_id') || '';
  } catch (error) {
    console.warn('[PD Review] Could not read design session ID:', error);
    return '';
  }
}
/* ---------- PAPER DOLLS REVIEW ANALYTICS ---------- */
const PD_REVIEW_GA4_ID = 'G-569BR0WE9N';

function pdReviewTrack(eventName, eventData = {}) {
  const designSessionId = getDesignSessionId();

  if (typeof window.gtag !== 'function') {
    console.warn('[PD Review Analytics] Google tag unavailable:', eventName);
    return false;
  }

  window.gtag('event', eventName, {
    send_to: PD_REVIEW_GA4_ID,
    business_line: 'paper_dolls',
    builder_version: 'pd26',
    design_session_id: designSessionId,
    ...eventData
  });

  console.log('[PD Review Analytics] Sent to GA4:', eventName, eventData);
  return true;
}

function trackReviewReachedOnce(designId, items) {
  const designSessionId = getDesignSessionId();
  const trackingKey = `pd_review_reached_${designSessionId}_${designId}`;

  try {
    if (window.sessionStorage.getItem(trackingKey)) return;
  } catch (error) {
    if (window.__pdReviewReachedTracked) return;
  }

  const sent = pdReviewTrack('pd_review_reached', {
    design_id: designId,
    line_item_count: items.length,
    page_path: window.location.pathname
  });

  if (!sent) return;

  try {
    window.sessionStorage.setItem(trackingKey, 'true');
  } catch (error) {
    window.__pdReviewReachedTracked = true;
  }
}

  function isBaseItem(item) {
    // Most reliable: your base variant id / handle. Handle shown in cart.js response.
    return item && item.handle === 'paper-dolls-26';
  
}
function isReviewAddon(item) {
  return getProp(item, '_pd_meta_type') === 'review_addon';
}

function getAddonItem(items, addonType) {
  return (items || []).find(item =>
    getProp(item, '_pd_meta_type') === 'review_addon' &&
    getProp(item, '_pd_addon_type') === addonType
  ) || null;
}

function formatMoney(cents) {
  return `$${(Number(cents || 0) / 100).toFixed(2)}`;
}

  function partLabel(item) {
    return getProp(item, 'Paper Dolls Part') || '';
  }

  function selectionLabel(item) {
    // Prefer explicit selection property, else fall back to title/variant.
    return getProp(item, 'Selection') ||
      [item.product_title, item.variant_title].filter(Boolean).join(' — ') ||
      item.title ||
      'Selection';
  }

function getPreviewImages(items) {
  return items
    .filter(it => !isBaseItem(it))
    .map(it => {
      const part = String(getProp(it, 'Paper Dolls Part') || '').toUpperCase();
      // Skip backs slots (no preview PNGs)
      if (['BACKLINE', 'CLOSURE', 'TRAIN'].includes(part)) return null;

      // Only use the explicit preview PNG property (no featured_image fallback)
      return getProp(it, '_preview_image') || null;
    })
    .filter(Boolean);
}


  function renderDesignCard(designId, items, settings) {
    const base = items.find(isBaseItem) || items[0];
    const priceCents = items.reduce((sum, it) => sum + (it.line_price || 0), 0);
    const previewImages = getPreviewImages(items);

const previewHtml = previewImages.length
  ? `<div class="pd-review__preview">
      ${previewImages.map(src =>
        `<img src="${esc(src)}" class="pd-review__preview-layer" alt="">`
      ).join('')}
    </div>`
  : '';



// Sort: base first, then by our part ordering, then alpha
const sorted = items.slice().sort((a, b) => {
  if (isBaseItem(a)) return -1;
  if (isBaseItem(b)) return 1;

  const A = getDisplayRow(a);
  const B = getDisplayRow(b);

  const ai = PART_ORDER.indexOf(A.partKey);
  const bi = PART_ORDER.indexOf(B.partKey);

  if (ai !== bi) return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);

  return (A.partText || '').localeCompare(B.partText || '');
});

function renderSelectionRow(it) {
  const r = getDisplayRow(it);

  const raw = String(r.selText || '').trim();

  let mainTitle = raw;
  let detailLines = [];

  if (raw.includes(' — ')) {
    const parts = raw.split(' — ');
    mainTitle = parts.shift() || raw;

    if (parts.length) {
      detailLines = parts.join(' — ').split(',').map(s => s.trim()).filter(Boolean);
    }
  }

  const detailHtml = detailLines.length
    ? `<div class="pd-review__row-details">
        ${detailLines.map(detail => `<div class="pd-review__row-detail">${esc(detail)}</div>`).join('')}
      </div>`
    : '';

  return `<li class="pd-review__row">
    <span class="pd-review__row-part">${esc(r.partText || 'PART')}</span>
    <span class="pd-review__row-sel">
      <div class="pd-review__row-title">${esc(mainTitle || 'Selection')}</div>
      ${detailHtml}
    </span>
  </li>`;
}

function renderStaticSelectionRow(partLabel, titleText) {
  return `<li class="pd-review__row">
    <span class="pd-review__row-part">${esc(partLabel)}</span>
    <span class="pd-review__row-sel">
      <div class="pd-review__row-title">${esc(titleText)}</div>
    </span>
  </li>`;
}

const gownRows = sorted
  .filter(it => !isBaseItem(it) && !isReviewAddon(it))
  .map(renderSelectionRow)
  .join('');

const rushItem = getAddonItem(items, 'rush');
const customSizingItem = getAddonItem(items, 'custom_sizing');

const productionRow = renderStaticSelectionRow(
  'Production',
  rushItem
    ? `Rush Production Upgrade (${formatMoney(rushItem.line_price || rushItem.final_line_price || 0)})`
    : 'Standard Production'
);

const fitRow = renderStaticSelectionRow(
  'Fit',
  customSizingItem
    ? `Custom Sizing Service (${formatMoney(customSizingItem.line_price || customSizingItem.final_line_price || 0)})`
    : 'Standard Sizing'
);

const rows = `
  ${gownRows || `<li class="pd-review__row"><span class="pd-review__row-sel">No selections found for this design.</span></li>`}
  <li class="pd-review__section-divider">
  <span class="pd-review__section-divider-text">Production &amp; Fit</span>
</li>
<li class="pd-review__row-group pd-review__row-group--two-col">
  ${productionRow}
  ${fitRow}
</li>
`;


    const total = (priceCents / 100).toFixed(2);

    // Builder URL comes from section setting via Liquid below; we’ll read it from a data attribute in CSS step.
    const backLink = settings?.builderUrl || '/pages/custom-gown-builder-parts';

   
    return `
  <article class="pd-review__card">
    <div class="pd-review__card-head">
      ${previewHtml}

      <div class="pd-review__meta">
        <div class="pd-review__card-body">
          <h3 class="pd-review__h3">Selections</h3>
          <ul class="pd-review__list">
            ${rows || `<li class="pd-review__row"><span class="pd-review__row-sel">No selections found for this design.</span></li>`}
          </ul>
        </div>

        <div class="pd-review__admin">
          <div class="pd-review__designid">Design ID: <strong>${esc(designId)}</strong></div>
          <div class="pd-review__total">Design total (cart): <strong>$${esc(total)}</strong></div>

          <div class="pd-review__actions">
  <a class="pd-review__btn pd-review__btn--secondary" href="${esc(backLink)}">Make changes</a>
  <button
    class="pd-review__btn pd-review__btn--primary pd-review__btn--scroll"
    type="button"
    data-pd-scroll-options
  >
    Looks great!
  </button>
</div>
        </div>
      </div>
    </div>
  </article>
`;
  }

  async function loadCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load cart');
    return await res.json();
  }

  function groupByDesign(cart) {
    const groups = new Map();

    (cart.items || []).forEach(item => {
      const did = getDesignId(item) || '__NO_DESIGN_ID__';
      if (!groups.has(did)) groups.set(did, []);
      groups.get(did).push(item);
    });

    return groups;
  }

  function getBuilderUrlFromDOM() {
    // Liquid setting gets put into a hidden element for reliable access:
    const el = document.querySelector('[data-pd-builder-url]');
    return el?.getAttribute('data-pd-builder-url') || '/pages/custom-gown-builder-parts';
  }
  function getRequestedDesignId() {
  const params = new URLSearchParams(window.location.search);
  return params.get('design_id');
}

  async function init() {
    try {
      // inject builder url from hidden element we’ll add via CSS file (below)
      const settings = { builderUrl: getBuilderUrlFromDOM() };

      const cart = await loadCart();
      const groups = groupByDesign(cart);

      // Empty cart handling
      if (!cart.items || cart.items.length === 0) {
        designsWrap.innerHTML = `
          <div class="pd-review__empty">
            Your cart is empty.
            <div style="margin-top:10px">
              <a class="pd-review__btn pd-review__btn--primary" href="${esc(settings.builderUrl)}">Build a design</a>
            </div>
          </div>
        `;
        return;
      }

     const validGroups = Array.from(groups.entries())
  .filter(([did]) => did !== '__NO_DESIGN_ID__');

const requestedDesignId = getRequestedDesignId();

let selectedGroup = null;

if (requestedDesignId) {
  selectedGroup = validGroups.find(([did]) => did === requestedDesignId) || null;
}

if (!selectedGroup && validGroups.length) {
  selectedGroup = validGroups[validGroups.length - 1];
}

if (selectedGroup) {
  const [did, items] = selectedGroup;
  root.setAttribute('data-pd-design-id', did);
  designsWrap.innerHTML = renderDesignCard(did, items, settings);
    trackReviewReachedOnce(did, items);

} else {
  designsWrap.innerHTML = `
    <div class="pd-review__empty">
      We couldn’t find a Design ID on your cart items yet.
      <div style="margin-top:10px">
        <a class="pd-review__btn pd-review__btn--secondary" href="/cart">View cart</a>
        <a class="pd-review__btn pd-review__btn--primary" href="${esc(settings.builderUrl)}">Return to builder</a>
      </div>
    </div>
  `;
}

    } catch (err) {
      console.error('[PD Review] render failed', err);
      designsWrap.innerHTML = `
        <div class="pd-review__error">
          We couldn’t load your design summary. Please refresh, or view your cart directly.
          <div style="margin-top:10px">
            <a class="pd-review__btn pd-review__btn--secondary" href="/cart">View cart</a>
          </div>
        </div>
      `;
    }
  }

  async function removeOtherDesignsBeforeCheckout(currentDesignId) {
  const cart = await loadCart();

  const itemsToRemove = (cart.items || []).filter(item => {
    const did = getDesignId(item);

    // Only remove Paper Dolls design-linked items.
    // Leave unrelated non-design products alone.
    return did && did !== currentDesignId;
  });

  for (const item of itemsToRemove) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Failed to remove hidden design item: ${text}`);
    }
  }
}

function initAcknowledgements() {
  const wrap = document.querySelector('[data-pd-acks]');
  if (!wrap) return;

  const checks = Array.from(wrap.querySelectorAll('[data-pd-ack]'));
  const button = wrap.querySelector('[data-pd-final-checkout]');
  if (!checks.length || !button) return;

  function updateButtonState() {
    const allChecked = checks.every(ch => ch.checked);

    if (allChecked) {
      button.classList.remove('pd-review__btn--disabled');
      button.setAttribute('aria-disabled', 'false');
      button.removeAttribute('tabindex');
    } else {
      button.classList.add('pd-review__btn--disabled');
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('tabindex', '-1');
    }
  }

  checks.forEach(ch => {
    ch.addEventListener('change', updateButtonState);
  });

 button.addEventListener('click', async function (e) {
  if (button.getAttribute('aria-disabled') === 'true') {
    e.preventDefault();
    return;
  }

  e.preventDefault();

  const designId = root.getAttribute('data-pd-design-id');

  if (!designId) {
    window.location.href = '/checkout';
    return;
  }

  const originalText = button.textContent;
  button.textContent = 'Preparing checkout...';
  button.classList.add('pd-review__btn--disabled');
  button.setAttribute('aria-disabled', 'true');

try {
  await removeOtherDesignsBeforeCheckout(designId);
  await attachDesignSessionIdToCart(designId);
  window.location.href = '/checkout';
  } catch (err) {
    console.error('[PD Review] checkout cleanup failed', err);
    alert('We could not prepare checkout just now. Please try again.');
    button.textContent = originalText;
    button.classList.remove('pd-review__btn--disabled');
    button.setAttribute('aria-disabled', 'false');
  }
});

  updateButtonState();
}

async function loadProductByHandle(handle) {
  const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
  if (!res.ok) throw new Error(`Failed to load product: ${handle}`);
  return await res.json();
}

function findAddonLineItems(cart, designId, addonType) {
  return (cart.items || []).filter(item =>
    getProp(item, '_pd_meta_type') === 'review_addon' &&
    getProp(item, '_pd_addon_type') === addonType &&
    getProp(item, 'Design ID') === designId
  );
}

async function removeAddonIfPresent(designId, addonType) {
  const cart = await loadCart();
  const lineItems = findAddonLineItems(cart, designId, addonType);
  if (!lineItems.length) return;

  for (const lineItem of lineItems) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: lineItem.key,
        quantity: 0
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Failed to remove addon ${addonType}: ${text}`);
    }
  }
}
async function updateLineItemProperties(lineItem, newProperties) {
  const existingProperties = lineItem.properties || {};

  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      id: lineItem.key,
      quantity: lineItem.quantity,
      properties: {
        ...existingProperties,
        ...newProperties
      }
    })
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to update line item properties: ${text}`);
  }

  return await res.json();
}

  async function removeFitAddons(designId) {
  await removeAddonIfPresent(designId, 'standard_sizing');
  await removeAddonIfPresent(designId, 'custom_sizing');
}
async function attachDesignSessionIdToCart(designId) {
  const designSessionId = getDesignSessionId();

  if (!designSessionId) {
    console.warn('[PD Review] No design session ID found; continuing without it.');
    return;
  }

  const cart = await loadCart();

  const designItems = (cart.items || []).filter(item =>
    getDesignId(item) === designId
  );

  for (const item of designItems) {
    if (getProp(item, '_pd_design_session_id') === designSessionId) {
      continue;
    }

    await updateLineItemProperties(item, {
      '_pd_design_session_id': designSessionId
    });
  }

  console.log(
    '[PD Review] Attached design session ID to cart:',
    designSessionId,
    designItems.length
  );
}

function formatMoney(cents) {
  return `$${(Number(cents || 0) / 100).toFixed(2)}`;
}
async function addAddonVariant(variantId, designId, addonType, extraProperties = {}) {
  const product = await loadProductByHandle(handle);
  const firstAvailableVariant =
    (product.variants || []).find(v => v.available) || product.variants[0];
  

  if (!firstAvailableVariant) {
    throw new Error(`No variant found for addon product: ${handle}`);
  }

  let partLabel = 'Part';
  let selectionLabel = product.title;

  if (addonType === 'rush') {
    partLabel = 'Production';
    selectionLabel = `Production: ${product.title} (${formatMoney(firstAvailableVariant.price)})`;
  }

  if (addonType === 'custom_sizing') {
    partLabel = 'Fit';
    selectionLabel = `Fit: ${product.title} (${formatMoney(firstAvailableVariant.price)})`;
  }

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      items: [
        {
          id: firstAvailableVariant.id,
          quantity: 1,
         properties: {
  'Design ID': designId,
  'Paper Dolls Part': partLabel,
  'Selection': selectionLabel,
  '_pd_meta_type': 'review_addon',
  '_pd_addon_type': addonType,
  ...extraProperties
}
        }
      ]
    })
  });
}
async function addAddonVariant(variantId, designId, addonType) {
  if (!variantId) {
    throw new Error(`Missing variant ID for addon type: ${addonType}`);
  }

  let partLabel = 'Fit';
  let selectionLabel = 'Fit Path';

  if (addonType === 'standard_sizing') {
    selectionLabel = 'Fit: Standard Size Selection';
  }

  if (addonType === 'custom_sizing') {
    selectionLabel = 'Fit: Custom Patterning';
  }

  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: {
            'Design ID': designId,
            'Paper Dolls Part': partLabel,
            'Selection': selectionLabel,
            '_pd_meta_type': 'review_addon',
            '_pd_addon_type': addonType
          }
        }
      ]
    })
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Failed to add fit variant ${variantId}: ${text}`);
  }

  return await res.json();
}

function syncReviewOptionsFromCart(cart, designId) {
  const items = cart.items || [];

  const hasRush = items.some(item =>
    getProp(item, '_pd_meta_type') === 'review_addon' &&
    getProp(item, '_pd_addon_type') === 'rush' &&
    getProp(item, 'Design ID') === designId
  );

  const hasCustomSizing = items.some(item =>
    getProp(item, '_pd_meta_type') === 'review_addon' &&
    getProp(item, '_pd_addon_type') === 'custom_sizing' &&
    getProp(item, 'Design ID') === designId
  );
  const hasStandardSizing = items.some(item =>
  getProp(item, '_pd_meta_type') === 'review_addon' &&
  getProp(item, '_pd_addon_type') === 'standard_sizing' &&
  getProp(item, 'Design ID') === designId
);

  const standardProduction = document.querySelector('input[name="pd-production"][value="standard"]');
  const rushProduction = document.querySelector('input[name="pd-production"][value="rush"]');

  const standardFit = document.querySelector('input[name="pd-fit"][value="standard"]');
  const customFit = document.querySelector('input[name="pd-fit"][value="custom"]');

  if (rushProduction && standardProduction) {
    rushProduction.checked = hasRush;
    standardProduction.checked = !hasRush;
  }

 if (customFit && standardFit) {
  customFit.checked = hasCustomSizing;
  standardFit.checked = hasStandardSizing || !hasCustomSizing;
}
}

async function initReviewOptions() {
  const wrap = document.querySelector('[data-pd-options]');
  if (!wrap) return;

  const designId = root.getAttribute('data-pd-design-id');
  if (!designId) return;

  const radios = Array.from(wrap.querySelectorAll('input[type="radio"]'));
  if (!radios.length) return;

  const cart = await loadCart();
  syncReviewOptionsFromCart(cart, designId);

  radios.forEach(radio => {
    radio.addEventListener('change', async function () {
      if (!this.checked) return;

      const groupName = this.name;
      const addonHandle = this.getAttribute('data-addon-handle');
      const addonType = this.getAttribute('data-addon-type');

      try {
        if (groupName === 'pd-production') {
          await removeAddonIfPresent(designId, 'rush');
          if (addonHandle && addonType) {
            await addAddon(addonHandle, designId, addonType);
          }
        }

       if (groupName === 'pd-fit') {
  const addonVariantId = this.getAttribute('data-addon-variant-id');

  console.log('[PD Review] Fit option clicked:', {
    addonVariantId,
    addonType,
    designId,
    value: this.value
  });

  if (!addonVariantId) {
    throw new Error(`Missing data-addon-variant-id for fit option: ${this.value}`);
  }

  if (!addonType) {
    throw new Error(`Missing data-addon-type for fit option: ${this.value}`);
  }

  await removeFitAddons(designId);
  await addAddonVariant(addonVariantId, designId, addonType);
}

        window.location.reload();
      } catch (err) {
        console.error('[PD Review] option update failed', err);
        alert('We could not update that option just now. Please try again.');
      }
    });
  });
}

function initScrollToOptions() {
  const trigger = document.querySelector('[data-pd-scroll-options]');
  const target = document.querySelector('[data-pd-options]');
  if (!trigger || !target) return;

  trigger.addEventListener('click', function () {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
}


async function saveStandardSizeChoice(sizeValue) {
  const designId = root.getAttribute('data-pd-design-id');
  if (!designId) throw new Error('Missing Design ID for size selection');

  const standardRadio = document.querySelector('input[name="pd-fit"][value="standard"]');
  const standardVariantId = standardRadio?.getAttribute('data-addon-variant-id');

  if (!standardVariantId) {
    throw new Error('Missing Standard Size Selection variant ID');
  }

  const sizeProperties = {
    'Selected Standard Size': sizeValue
  };

  const cart = await loadCart();
  const existingStandardLine = findAddonLineItems(cart, designId, 'standard_sizing')[0];

  if (existingStandardLine) {
    await updateLineItemProperties(existingStandardLine, sizeProperties);
  } else {
    await removeFitAddons(designId);
    await addAddonVariant(standardVariantId, designId, 'standard_sizing', sizeProperties);
  }
}
function initStandardSizeModal() {
  const modal = document.querySelector('[data-pd-standard-size-modal]');
  const opener = document.querySelector('[data-pd-standard-size-open]');
  const closeBtn = document.querySelector('[data-pd-standard-size-close]');
  const sizeSelect = document.querySelector('[data-pd-standard-size-select]');
const saveBtn = document.querySelector('[data-pd-standard-size-save]');
const status = document.querySelector('[data-pd-standard-size-status]');

  if (!modal || !opener || !closeBtn) return;

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

opener.addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  openModal();
});

  closeBtn.addEventListener('click', closeModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

    if (saveBtn && sizeSelect) {
    saveBtn.addEventListener('click', async function () {
      const sizeValue = sizeSelect.value;

      if (!sizeValue) {
        if (status) status.textContent = 'Please choose a size or select “I’ll choose after checkout.”';
        return;
      }

      const originalText = saveBtn.textContent;
      saveBtn.textContent = 'Saving...';
      saveBtn.disabled = true;

      try {
        await saveStandardSizeChoice(sizeValue);
        if (status) status.textContent = `Saved: ${sizeValue}`;

        setTimeout(() => {
          window.location.reload();
        }, 500);
      } catch (err) {
        console.error('[PD Review] standard size save failed', err);
        if (status) status.textContent = 'We could not save that size just now. Please try again.';
        saveBtn.textContent = originalText;
        saveBtn.disabled = false;
      }
    });
  }
}

init().then(() => {
  initAcknowledgements();
  initReviewOptions();
  initScrollToOptions();
  initStandardSizeModal();
});
})();
